import React from "react";

const CoursesHeader = () => {
  return (
    <div className="row bg-dark mt-5 py-4">
      <div className="text-center text-primary">
        <h2 className="text-light h3 pt-3">
          Construye una carrera haciendo lo que amas
        </h2>
      </div>
    </div>
  );
};
export default CoursesHeader;
